import * as React from 'react'
import Box from '@mui/material/Box'
import TextField from 'components/Common/TextField'
// import FormTextField from 'components/Common/Form/FormTextField'
import './index.css'
import FilterBox from '../FilterBox'
import IndustryDropDown from 'components/Common/IndustryAutoComplete'
import PlaceAutoComplete from 'components/Common/PlaceAutoComplete'
import { useSelector, useDispatch } from 'react-redux'
import { updateSearchCriteria, fetchFetchCompany } from 'store/actions/businessListingActions'
import { useState } from 'react'
import Button from 'components/Common/Button'
import { PRIMARY_BUTTON, DISABLED_BUTTON } from 'themes/theme'

const SearchBar = () => {
  const businessReducer = useSelector(state => state.businessReducer)
  const { searchCriteria } = businessReducer
  const [derivadValue, setDerivedValue] = useState(searchCriteria)
  const dispatch = useDispatch()

  const searchButtonEnabled = searchCriteria.companyName || searchCriteria.address || searchCriteria.industry

  if (derivadValue !== searchCriteria) {
    setDerivedValue(searchCriteria)
  }

  const handleChange = search => {
    const { value, name } = search
    updateSearchCriteria(dispatch, {
      ...searchCriteria,
      [name]: value,
    })
  }

  const handleSearch = e => {
    e.preventDefault()
    const updatedSearchCriteria = { ...searchCriteria, skip: 0 }
    updateSearchCriteria(dispatch, updatedSearchCriteria)
    fetchFetchCompany(dispatch, updatedSearchCriteria)
  }

  return (
    <Box component="form" autoComplete="off" className="row mb-5" onSubmit={handleSearch} sx={{ alignItems: 'center' }}>
      <Box className="col-sm-12 col-md-3 ">
        <TextField
          size="small"
          name="companyName"
          fullWidth
          borderLess
          InputLabelProps={{ shrink: false }}
          className="customInput bootstrapLabel"
          label="Business Name"
          variant="outlined"
          onChange={e =>
            handleChange({
              value: e.target.value,
              name: e.target.name,
            })
          }
          value={searchCriteria.companyName}
        />
      </Box>
      <Box className="col-sm-12 col-md-3">
        <PlaceAutoComplete
          required={false}
          label="Location"
          borderLess
          name="address"
          handleValue={handleChange}
          defaultValue={searchCriteria.address}
        />
      </Box>
      <Box className="col-sm-12 col-md-3">
        <IndustryDropDown handleValue={handleChange} borderLess defaultValue={searchCriteria.industry} />
      </Box>
      <Box className="col-sm-12 col-md-3">
        <Box display="flex" gap="15px" justifyContent="left" marginTop="25px">
          <Button
            type={searchButtonEnabled ? PRIMARY_BUTTON : DISABLED_BUTTON}
            disabled={!searchButtonEnabled}
            submit
            sx={{width: '220px', height: '50px'}}
          >
            Search
          </Button>
          <FilterBox />
        </Box>
      </Box>
    </Box>
  )
}

export default SearchBar
